import { createGlobalStyle } from 'styled-components';

/* Design-system stylesheet for the Soomuch one-pager. Everything lives under
   .sm1p so the rest of the site is untouched. The !important hover states
   mirror the source file's style-hover rules, which overrode inline styles. */

const OnePagerStyles = createGlobalStyle`
  .sm1p {
    max-width: 100vw;
    overflow-x: clip;
    background: linear-gradient(180deg, #ffffff 0%, #f7faff 30%, #ffffff 58%);
    font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
    -webkit-font-smoothing: antialiased;
    color: #0f172a;
  }

  .sm1p a {
    color: #2563eb;
    text-decoration: none;
  }
  .sm1p a:hover {
    color: #1d4ed8;
  }
  .sm1p input,
  .sm1p button,
  .sm1p select,
  .sm1p textarea {
    font-family: 'Plus Jakarta Sans', system-ui, sans-serif;
  }

  @keyframes sm1p-pop {
    0% { opacity: 0; transform: scale(0.6); }
    60% { opacity: 1; transform: scale(1.08); }
    100% { transform: scale(1); }
  }
  @keyframes sm1p-slideover {
    from { opacity: 0.4; transform: translateX(40px); }
    to { opacity: 1; transform: none; }
  }
  @keyframes sm1p-fadein {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  @keyframes sm1p-slidein {
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: none; }
  }
  @keyframes sm1p-drift {
    50% { transform: translateY(-16px); }
  }

  /* Header nav links */
  .sm1p a.sm1p-navlink:hover {
    background: #eff6ff !important;
    color: #2563eb !important;
  }
  /* Header GET EARLY ACCESS */
  .sm1p button.sm1p-cta-header:hover {
    background: #1d4ed8 !important;
    box-shadow: 0 12px 26px rgba(37,99,235,.32) !important;
  }
  /* Hide header GET EARLY ACCESS on tablet + mobile */
  @media (max-width: 1024px) {
    .sm1p button.sm1p-cta-header {
      display: none !important;
    }
  }
  /* Stack hero on tablet + mobile so the dashboard mock gets full width */
  @media (max-width: 1024px) {
    .sm1p .sm1p-hero-grid {
      grid-template-columns: 1fr !important;
    }
  }
  /* Scale the desktop dashboard mock down to fit small screens (layout kept intact) */
  @media (max-width: 480px) {
    .sm1p .sm1p-dash-scale {
      zoom: 0.62;
    }
  }
  @media (min-width: 481px) and (max-width: 640px) {
    .sm1p .sm1p-dash-scale {
      zoom: 0.78;
    }
  }
  /* Hero + roadmap primary CTA */
  .sm1p button.sm1p-cta-hero:hover {
    background: #1d4ed8 !important;
    transform: translateY(-1px) !important;
  }
  /* Watch Video ghost button */
  .sm1p button.sm1p-btn-video:hover {
    border-color: #2563eb !important;
    color: #2563eb !important;
    background: #fff !important;
  }
  /* Feature cards */
  .sm1p .sm1p-feature-card {
    transition: transform 0.18s ease, box-shadow 0.18s ease;
  }
  .sm1p .sm1p-feature-card:hover {
    transform: translateY(-3px) !important;
    box-shadow: 0 18px 38px -18px rgba(15,45,107,.3) !important;
    border-color: #cfe1fa !important;
  }
  /* Contact dark CTA */
  .sm1p button.sm1p-btn-dark:hover {
    background: #1e3a8a !important;
    transform: translateY(-1px) !important;
  }
  /* Footer links + social icons */
  .sm1p a.sm1p-footer-link:hover,
  .sm1p button.sm1p-footer-link:hover {
    color: #2563eb !important;
  }
  /* Modal close buttons */
  .sm1p button.sm1p-icon-btn:hover {
    background: #e0edff !important;
  }
  /* Full-width primary buttons (request access, done, send enquiry) */
  .sm1p button.sm1p-btn-block:hover {
    background: #1d4ed8 !important;
  }
  /* Enquiry interest chips */
  .sm1p button.sm1p-chip:hover {
    border-color: #2563eb !important;
  }
  /* Legal drawer jump pills */
  .sm1p button.sm1p-jump:hover {
    border-color: #2563eb !important;
    color: #2563eb !important;
  }
  /* Legal drawer tabs */
  .sm1p button.sm1p-tab:hover {
    color: #2563eb !important;
  }
`;

export default OnePagerStyles;
